const map = {
	"./ar/admin_user.json": 1376,
	"./ar/ai_chat.json": 8524,
	"./ar/auth.json": 1901,
	"./ar/billing.json": 5242,
	"./ar/cancel_reason.json": 6034,
	"./ar/category.json": 6963,
	"./ar/common.json": 8634,
	"./ar/country.json": 9919,
	"./ar/coupon.json": 1177,
	"./ar/dashboard.json": 3581,
	"./ar/help_support.json": 6756,
	"./ar/history_log.json": 2248,
	"./ar/language_page.json": 7653,
	"./ar/login.json": 5108,
	"./ar/loyalty.json": 7475,
	"./ar/message_code.json": 8734,
	"./ar/multi_lang.json": 1809,
	"./ar/notification.json": 7096,
	"./ar/order.json": 7413,
	"./ar/outlet_change_request.json": 7941,
	"./ar/package.json": 5145,
	"./ar/register.json": 3446,
	"./ar/review_moderation.json": 3176,
	"./ar/roles.json": 2392,
	"./ar/salon.json": 2684,
	"./ar/sidebar.json": 8381,
	"./ar/system_config.json": 893,
	"./ar/user_app.json": 6992,
	"./en/admin_user.json": 7264,
	"./en/ai_chat.json": 5580,
	"./en/auth.json": 5021,
	"./en/billing.json": 2282,
	"./en/cancel_reason.json": 1602,
	"./en/category.json": 4355,
	"./en/common.json": 9802,
	"./en/country.json": 4479,
	"./en/coupon.json": 297,
	"./en/dashboard.json": 6061,
	"./en/help_support.json": 9716,
	"./en/history_log.json": 5256,
	"./en/language_page.json": 6053,
	"./en/login.json": 788,
	"./en/loyalty.json": 1523,
	"./en/message_code.json": 8206,
	"./en/multi_lang.json": 3585,
	"./en/notification.json": 7016,
	"./en/order.json": 6389,
	"./en/outlet_change_request.json": 4757,
	"./en/package.json": 5801,
	"./en/register.json": 8806,
	"./en/review_moderation.json": 7144,
	"./en/roles.json": 472,
	"./en/salon.json": 3884,
	"./en/sidebar.json": 6189,
	"./en/system_config.json": 1597,
	"./en/user_app.json": 7792,
	"./ru/admin_user.json": 7946,
	"./ru/ai_chat.json": 6298,
	"./ru/auth.json": 1783,
	"./ru/billing.json": 8268,
	"./ru/cancel_reason.json": 304,
	"./ru/category.json": 8261,
	"./ru/common.json": 1444,
	"./ru/country.json": 7261,
	"./ru/coupon.json": 795,
	"./ru/dashboard.json": 5195,
	"./ru/help_support.json": 5598,
	"./ru/history_log.json": 5662,
	"./ru/language_page.json": 2895,
	"./ru/login.json": 4702,
	"./ru/loyalty.json": 797,
	"./ru/message_code.json": 7320,
	"./ru/multi_lang.json": 2463,
	"./ru/notification.json": 1066,
	"./ru/order.json": 6767,
	"./ru/outlet_change_request.json": 2147,
	"./ru/package.json": 7203,
	"./ru/register.json": 3008,
	"./ru/review_moderation.json": 7102,
	"./ru/roles.json": 8538,
	"./ru/salon.json": 5358,
	"./ru/sidebar.json": 4999,
	"./ru/system_config.json": 9475,
	"./ru/user_app.json": 4574,
	"./vi/admin_user.json": 10,
	"./vi/ai_chat.json": 2618,
	"./vi/auth.json": 9591,
	"./vi/billing.json": 4156,
	"./vi/cancel_reason.json": 8352,
	"./vi/category.json": 1157,
	"./vi/common.json": 5060,
	"./vi/country.json": 6493,
	"./vi/coupon.json": 9467,
	"./vi/dashboard.json": 2475,
	"./vi/help_support.json": 2158,
	"./vi/history_log.json": 2990,
	"./vi/language_page.json": 2543,
	"./vi/login.json": 1278,
	"./vi/loyalty.json": 6957,
	"./vi/message_code.json": 6072,
	"./vi/multi_lang.json": 4735,
	"./vi/notification.json": 2378,
	"./vi/order.json": 3247,
	"./vi/outlet_change_request.json": 4755,
	"./vi/package.json": 6288,
	"./vi/register.json": 400,
	"./vi/review_moderation.json": 1102,
	"./vi/roles.json": 6906,
	"./vi/salon.json": 1694,
	"./vi/sidebar.json": 6983,
	"./vi/system_config.json": 7267,
	"./vi/user_app.json": 6270,
	"./zh/admin_user.json": 7339,
	"./zh/ai_chat.json": 5713,
	"./zh/auth.json": 6538,
	"./zh/billing.json": 1211,
	"./zh/cancel_reason.json": 5547,
	"./zh/category.json": 4328,
	"./zh/common.json": 197,
	"./zh/country.json": 4326,
	"./zh/coupon.json": 9150,
	"./zh/dashboard.json": 412,
	"./zh/help_support.json": 7179,
	"./zh/history_log.json": 9005,
	"./zh/language_page.json": 3852,
	"./zh/login.json": 3553,
	"./zh/loyalty.json": 6450,
	"./zh/message_code.json": 2297,
	"./zh/multi_lang.json": 9414,
	"./zh/notification.json": 4607,
	"./zh/order.json": 2680,
	"./zh/outlet_change_request.json": 8204,
	"./zh/package.json": 8152,
	"./zh/register.json": 1181,
	"./zh/review_moderation.json": 9581,
	"./zh/roles.json": 6237,
	"./zh/salon.json": 3921,
	"./zh/sidebar.json": 1748,
	"./zh/system_config.json": 5540,
	"./zh/user_app.json": 1383
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4707;